import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { NonPcnMutations } from '../mutation';
import { DASHBOARD_QUERY_KEYS } from '@api/services/dashboard';

export const useAddNonPcnMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: NonPcnMutations.addNonPcn,
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: [DASHBOARD_QUERY_KEYS.GET_DASHBOARD],
      });
      await navigate({ to: '/forms' });
    },
  });
};
